import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent {
  /***
   Valor em porcentagem da barra de progresso
  ***/
  @Input() value: number;

  @Input() showValue: boolean = true;

  @Input() style: any;

  @Input() styleClass: string;

  @Input() unit: string = '%';

  @Input() mode: string = 'determinate';

  @Input() formatter?: (value: number) => string | number;

  get val() {
    if (this.formatter) {
      return this.formatter(this.value);
    }
    return this.value.toLocaleString();
  }
}
